import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthContext, AuthProvider } from "./contexts/AuthContext";
import { useContext } from "react";
import AuthLayout from "./layouts/AuthLayout";
import MainLayout from "./layouts/MainLayout";
import HomeLayout from "./layouts/HomeLayout";
import Dashboard from "./pages/dash/Dashboard";
import Bookings from "./pages/bookings/Bookings";
import Manage from "./pages/manage/Manage";
import Calendar from "./pages/calendar/Calendar";
import Sites from "./pages/manage/sites/Sites";
import Users from "./pages/manage/users/Users";
import Services from "./pages/manage/services/Services";
import Slots from "./pages/manage/slots/Slots";
import Signin from "./pages/auth/Signin";
import Verify from "./pages/auth/Verify";

function App() {
  const queryClient = new QueryClient();
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Routes>
          <Route element={<HomeLayout />}>
          </Route>
          <Route element={<AuthLayout />}>
            <Route path="/" element={<Signin />} />
            <Route path="/verify" element={<Verify />} />
          </Route>
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/bookings" element={<ProtectedRoute><Bookings /></ProtectedRoute>} />
            <Route path="/calendar" element={<ProtectedRoute><Calendar /></ProtectedRoute>} />
            <Route path="/manage" element={<ProtectedRoute><Manage /></ProtectedRoute>} />
            <Route path="/manage/slots" element={<ProtectedRoute><Slots /></ProtectedRoute>} />
            <Route path="/manage/sites" element={<ProtectedRoute><Sites /></ProtectedRoute>} />
            <Route path="/manage/services" element={<ProtectedRoute><Services /></ProtectedRoute>} />
            <Route path="/manage/users" element={<ProtectedRoute><Users /></ProtectedRoute>} />
          </Route>
        </Routes>
      </AuthProvider>
    </QueryClientProvider>
  );
}

function ProtectedRoute({ children }: { children: JSX.Element }) {
  let { user } = useContext(AuthContext);
  let location = useLocation();
  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return children;
}

export default App;
